/**
 * Toggle classes
 * @module switchClass
 */

 import $ from 'jquery';
 import registerJQueryPlugin from '../lib/register-jquery-plugin';
 import mergeOptions from '../lib/merge-options';

 // Expose the function as a jQuery plugin for ease of use
 export const PLUGIN_NAME = 'switchClass';
 export const DEFAULTS = {
   switchClass: '',
   switchTarget: '',
   isActive: () => {},
 };
 /**
  * Applies any sort of event handlers for the switchClass.
  * @param  {jQuery} $el - link
  * @param  {Object} [options={}] - Any options provided upon initialization
  */

  const setEventListeners = ($el, options = {}) => {
    $el.on('click', (evt) => {
      evt.preventDefault();
      let $changingElClass;
       // If the href attribute is defined and not equal to '#', use it to select the target element
      if ($el.attr('href') !== undefined && $el.attr('href') !== '#') {
        $changingElClass = $($el.attr('href'));
      }
      // If a data-switch-target attribute was used instead of href
      if (options.switchTarget && options.switchTarget !== '') {
        $changingElClass = $(options.switchTarget);
      // If a data-target-element attribute was used instead of data-switch-target
      } else if (options.targetElement && options.targetElement !== '') {
        $changingElClass = $(options.targetElement);
      }
      if (!$changingElClass) {
        return;
      }
      $changingElClass.toggleClass(options.switchClass);
      if ($changingElClass.hasClass(options.switchClass)) {
        options.isActive();
      }
    });
  };

 /**
  * Initializes switchClass.
  * @param {HTMLElement} el - link
  * @param {Object} options - Options used for wiring up the modal
  * @see DEFAULTS
  */
 export default function switchClass(el, options = {}) {
   const $el = $(el);
   const opts = mergeOptions(DEFAULTS, options, $el);
   setEventListeners($el, opts);
 }
 registerJQueryPlugin(PLUGIN_NAME, switchClass);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/switch-class.js